import React, { Component } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, updateData, deleteItem} from './constants.js';

function ResidentList(props) {
    let navigate = useNavigate();
    const resident_list = props.data.map((item, index)=>
      <tr key={item.id} id={item.id}>
          <td>{index+1}</td>
          <td className="text-nowrap">{item.lot_no}</td>
          <td>{item.first_name} {item.last_name}</td>
          {/*
          <td>{item.city}</td>
          <td>{item.state}</td>
          <td className="text-nowrap">{item.zip_code}</td>
          */}

          <td>{item.wo_street_address}</td>
          {/*<td className={item.status?"text-success":"text-danger"}>{item.status?"Active":"Inactive"}</td>*/}
          <td>
            <div className="row">
              <div className="col">
                <i className="fas fa-pencil-alt text-warning action-icons" onClick={()=> navigate('/edit-resident/'+item.id) }></i>
              </div>
              <div className="col">
                <i id={item.id} className="fas fa-trash-alt text-danger action-icons" onClick={props.delete}></i>
              </div>
            </div>
          </td>
      </tr>
    );
    return(
        <>
        <div className="row">
            <div className="col-12">

                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h4 className="m-0 font-weight-bold text-white">Property Owners</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive resident-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Lot No.</th>
                                        <th>Property Owner Name</th>
                                        {
                                        /*<th>City</th>
                                        <th>State</th>
                                        <th>Zip Code</th>*/
                                        }
                                        <th>Address</th>
                                        {/*<th>Status</th>*/}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {resident_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

class Residents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true
    };
    this.deleteResident = this.deleteResident.bind(this);
  }

  async getResidents() {
    try {
      const response = await fetch('/api/residents');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  deleteResident(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/resident/"+id)
    .then((response) => {
      console.log(response);
      this.getResidents();
    });
  }

  componentDidMount() {
    this.getResidents();
  }

  render() {
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <ResidentList data={this.state.data} delete={this.deleteResident}/>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

class ResidentForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        fees                : [],
        properties          : [],
        lots                : {},
        id                  : "",
        first_name          : "",
        last_name           : "",
        lot_no              : "",
        wo_street_address   : "",
        owner_street_address: "",
        city                : "",
        state_id            : "FL",
        zip_code            : "",
        email               : "",
        phone               : "",
        country             : "US",
        state               : "",
        fee_id              : "",
        status              : "1",
        previous_owner      : "",
        isLoading           :true,
        owner_address_check : false
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleOwnerAddressCheck = this.handleOwnerAddressCheck.bind(this);
      this.handleChangeWOStreetAddress = this.handleChangeWOStreetAddress.bind(this);
    }

    async getResident(id) {
      try {
        const response = await fetch('/api/resident/'+id);
        const json = await response.json();
        console.log(json);
        if(json.owner_street_address.length>0){
          json.owner_address_check = true;
        }
        this.setState(json);
      } catch (error) {
        console.log(error);
      }
    }

    async getFees() {
      try {
        const response = await fetch('/api/fees');
        const json = await response.json();
        const active_fees = json.filter(e=>e.status===1);
        this.setState({fees : active_fees, fee_id:active_fees.length?active_fees[0].id:""});
      } catch (error) {
        console.log(error);
      } finally {
        this.setState({ isLoading: false });
      }
    }

    async getProperties() {
      try {
        const response = await fetch('/api/properties');
        const json = await response.json();
        const lots = json.reduce((a,c)=>{
          a[c.wostreetaddress] = c.lotnumber;
          return a;
        }, {});
        this.setState({properties : json, lots});
      } catch (error) {
        console.log(error);
      } finally {
        this.setState({ isLoading: false });
      }
    }    

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;

      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      const data = this.state;
      delete data.fees;
      delete data.isLoading;
      console.log(data);

      if(data.id){
        updateData('/api/resident/'+data.id, data)
          .then((response) => {
            console.log(response);
            this.props.navigate('/residents');
        });
      }else{
        postData('/api/resident', data)
          .then((response) => {
            console.log(response);
            this.props.navigate('/residents');
        });
      }
    }

    handleOwnerAddressCheck(event) {
      this.setState({owner_address_check: !this.state.owner_address_check})
    }

    handleChangeWOStreetAddress(event) {
      this.setState({wo_street_address: event.target.value});
      this.setState({lot_no: this.state.lots[event.target.value]})
    }

    componentDidMount() {
      const residentId = this.props.residentId;
      if(residentId) this.getResident(residentId);
      this.getFees();
      this.getProperties();
    }

    render() {
      const fees = this.state.fees;
      const fee_options = fees.map((p)=>
        <option key={p.id} value={p.id}>{p.name}</option>
      );
      const properties = this.state.properties.map((a,i)=>
        <option key={i}>{a.wostreetaddress}</option>
      );
      const data = this.state;
      return(
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h4 className="m-0 font-weight-bold text-white">Add / Edit Property Owner</h4>
          </div>
          <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
            <div className="card-body">
              <div className="row">                
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>First Name</label>
                    <input type="text" name="first_name" className="form-control" value={data.first_name} onChange={this.handleInputChange} autoComplete="1" required />
                  </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Last Name</label>
                    <input type="text" name="last_name" className="form-control" value={data.last_name} onChange={this.handleInputChange} autoComplete="2" />
                  </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Email</label>
                    <input type="text" name="email" className="form-control" value={data.email} onChange={this.handleInputChange} required autoComplete="3"/>
                  </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="text" name="phone" className="form-control" value={data.phone} onChange={this.handleInputChange} required  autoComplete="4"/>
                  </div>
                </div>                      
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Whispering Oaks Address</label>
                    <select name="wo_street_address" className="form-control" value={data.wo_street_address} onChange={this.handleChangeWOStreetAddress} required>
                      <option key="-1" value="">Select address from the list</option>
                      {properties}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Lot Number</label>
                    <input type="text" name="lot_no" className="form-control" value={data.lot_no} onChange={this.handleInputChange} required />
                  </div>
                </div>  
                <div className="col">
                  <label className="form-label mr-3">Is the property owner currently living in the above address? </label>
                  <div className="btn-group">
                    <button id="btn-owner-address-yes" type="button" name="owner_address_yes" className={data.owner_address_check?"btn border border-dark btn-default":"btn border border-dark btn-success"} onClick={this.handleOwnerAddressCheck} >Yes</button>
                    <button id="btn-owner-address-no" type="button" name="owner_address_no" className={data.owner_address_check?"btn border border-dark btn-success":"btn border border-dark btn-default"} onClick={this.handleOwnerAddressCheck} >No</button>
                  </div>
                </div>  
              </div>
            </div>
            {
            data.owner_address_check &&
            <div className="card-body bg-light m-2 mb-4">
              <p>Please enter owner current mailing address</p>
            
              <div className="row">                   
                <div className="col-lg-4 col-xs-12">
                  <div className="form-group">
                    <label>Owner Street Address</label>
                    <input type="text" name="owner_street_address" rows="1" className="form-control" value={data.owner_street_address} onChange={this.handleInputChange}/>
                  </div>
                </div>
                <div className="col-lg-3 col-xs-12">
                  <div className="form-group">
                    <label>City</label>
                    <input name="city" className="form-control" value={data.city} onChange={this.handleInputChange} />
                    {/*
                      <select name="city" className="form-select" value={data.city} onChange={this.handleInputChange} >
                        <option>Tampa</option>
                        <option>Ridge Manor</option>
                        <option>Greenacres</option>
                        <option>Carlyle</option>
                        <option>Peachtree Corners</option>
                        <option>Dade City</option>
                        <option>Atlanta</option>
                        <option>Zephyrhills</option>
                        <option>Edmond</option>
                        <option>Schenectady </option>
                        <option>Honey Brook</option>
                        <option>Ormond Beach</option>
                        <option>Spring Hill</option>
                        <option>Webster</option>
                        <option>Land O'Lakes</option>
                        <option>Muskegon</option>
                        <option>Wyandotte</option>
                        <option>Waverly</option>
                        <option>Brandon</option>
                        <option>Saline</option>
                        <option>Bethel</option>
                        <option>Scottsdale</option>
                        <option>Hudson</option>
                        <option>Amherst</option>
                        <option>W. Keansburg</option>
                        <option>Lutz</option>
                        <option>Clifton Park</option>
                        <option>Apollo Beach</option>
                        <option>Burlington</option>
                        <option>Bushnell</option>
                        <option>Homosassa</option>
                        <option>Mt Airy</option>
                        <option>Surry</option>
                        <option>Brooksville</option>
                        <option>Griswold</option>
                        <option>SaltLake City</option>
                        <option>Shelbyville</option>
                        <option>Port Richey</option>
                        <option>Leesburg</option>
                        <option>Centennial</option>
                        <option>Greenville</option>
                        <option>Bridgeton</option>
                        <option>Pardeeville</option>
                        <option>Clymer</option>
                        <option>Wesley Chapel</option>
                      </select>
                    */}
                  </div>
                </div>
                <div className="col-lg-2 col-xs-12">
                  <div className="form-group">
                    <label>State</label>
                    <select name="state_id" className="form-select" value={data.state_id} onChange={this.handleInputChange} >
                      <option>FL</option>
                      <option>IL</option>
                      <option>GA</option>
                      <option>OK</option>
                      <option>NY</option>
                      <option>PA</option>
                      <option>MI</option>
                      <option>IA</option>
                      <option>ME</option>
                      <option>AZ</option>
                      <option>OH</option>
                      <option>NJ</option>
                      <option>CT</option>
                      <option>MD</option>
                      <option>NH</option>
                      <option>UT</option>
                      <option>KY</option>
                      <option>CO</option>
                      <option>WI</option>
                    </select>
                  </div>
                </div>                
                <div className="col-lg-3 col-xs-12">
                  <div className="form-group">
                    <label>Zip Code</label>
                    <input type="text" name="zip_code" className="form-control" value={data.zip_code} onChange={this.handleInputChange} required />
                  </div>
                </div>
              </div>
            </div>                
            }
            <div className="col-lg-12 col-xs-12">
              <div className="form-group float-right">
                <input type="submit" id="asset-submit" className="btn btn-bg-success" value="Submit" />
                <Link to="/residents" className="btn ms-3 btn-danger">Cancel</Link>
              </div>
            </div>            
          </form>
        </div>
      );
    }
}

function AddResident() {
    const { id } = useParams();
    let navigate = useNavigate();
    return (
      <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      <ResidentForm residentId={id} navigate={navigate} />
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
      </>
    );
  }

export { Residents, AddResident };
